import { Box, Flex, Image, Spacer, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import type { ProcessRead, WorkflowProcess } from "@nens/rana/api-v1";
import { RanaButton, RanaHeading, RightArrowIcon, SIZES } from "@nens/ranalib";

import WorkflowFallbackImg from "@/images/workflow-no-image.png";
import { getProcessImageSrc } from "@/utils/get-process-image-src";

interface WorkflowProcessCardProps {
  process: WorkflowProcess;
  processDefinition?: ProcessRead;
  onClick: () => void;
}

export function WorkflowProcessCard({
  process,
  processDefinition,
  onClick,
}: WorkflowProcessCardProps) {
  const imageSrc = getProcessImageSrc(processDefinition?.tags) ?? WorkflowFallbackImg;

  return (
    <RanaButton variant="listitem" onClick={onClick} h="xs" textAlign="left" p={0}>
      <Flex h="full" w="full" flexDir="column" p={2} pb={4} color="brand.deep_sea">
        <Box
          flexShrink={0}
          w="full"
          h={`calc(${SIZES.xs} / 2)`}
          rounded="base"
          overflow="hidden"
          mb={2}
        >
          <Image w="full" h="full" objectFit="cover" objectPosition="center" src={imageSrc} />
        </Box>
        <RanaHeading type="h4">{process.title}</RanaHeading>
        <Text mt={2} fontSize="sm" fontWeight="normal">
          <FormattedMessage
            id="workflow.process_description"
            defaultMessage="Run this process as part of the workflow."
          />
        </Text>
        <Spacer />
        <Flex alignSelf="flex-end" mt={2} alignItems="center" color="brand.analytic" fontSize="sm">
          <FormattedMessage id="workflow.use_process" defaultMessage="Use process" />
          <RightArrowIcon ml={2} />
        </Flex>
      </Flex>
    </RanaButton>
  );
}
